export default __webpack_public_path__ + "static/media/quiz_bg_mobile.75a752f0.png";